<template>
  <div v-if="dataHistoryReschedule.length === 0" style="min-height: 50vh">
    <div class="columns is-centered">
      <div class="column has-text-centered">
        <ProyekEmptyIcon />
        <p class="averta-bold">Tidak Ada Riwayat Reschedule</p>
      </div>
    </div>
  </div>
  <div v-else class="wrap-history">
    <div class="card p-4">
      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center"
      >
        <p class="averta-bold label-16 color-blue-1">
          Tanggal Awal:
          {{ convertDate(dataHistoryReschedule[dataHistoryReschedule.length - 1].original_date) }}
          {{
            dataHistoryReschedule[dataHistoryReschedule.length - 1].original_start_time
              ? `(${dataHistoryReschedule[dataHistoryReschedule.length - 1].original_start_time})`
              : ''
          }}
        </p>
      </div>
      <div
        class="is-flex is-flex-direction-row is-justify-content-flex-center is-align-items-center c-w-100 mt-4"
      >
        <!-- Content Table -->
        <div class="content-table-history">
          <div class="header-table-history">
            <div class="row-content-table-history">
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Tanggal Permintaan</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Nama</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Tanggal Baru</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Catatan</p>
              </div>
              <div class="data-table-history">
                <p class="averta-bold label-14 color-white">Status</p>
              </div>
            </div>
          </div>
          <div class="body-table-history">
            <div
              v-for="(dataHistory, indexHistory) in dataHistoryReschedule"
              :key="`${indexHistory}-history`"
              class="row-content-table-history"
              style="border-bottom: 1px solid #e1e1e1; background: #ffffff"
            >
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{
                    dataHistory.created_at
                      ? moment(dataHistory.created_at).format('dddd, DD MMMM YYYY (HH:mm)')
                      : ''
                  }}
                </p>
              </div>
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{ dataHistory.created_by_name }}
                </p>
              </div>
              <div class="data-table-history">
                <p class="averta-regular label-14 color-black has-text-centered">
                  {{ convertDate(dataHistory.actually_date || dataHistory.date) }}
                  {{ dataHistory.start_time ? `(${dataHistory.start_time})` : '' }}
                </p>
              </div>
              <div class="data-table-history">
                <b-tooltip
                  v-if="dataHistory.reason"
                  :label="dataHistory.reason"
                  position="is-bottom"
                  size="is-large"
                  multilined
                  append-to-body
                  type="is-black"
                >
                  <p class="averta-regular label-14 color-black has-text-centered">
                    {{ safeSubstring(dataHistory.reason, 65) }}
                  </p>
                </b-tooltip>
                <div
                  v-else
                  class="is-flex is-flex-direction-row is-justify-content-center is-align-items-center c-w-100 c-h-100"
                >
                  <p class="averta-regular is-font-14 black-color has-text-centered">-</p>
                </div>
              </div>
              <div class="data-table-history">
                <span
                  class="badge-status"
                  :class="`wrap-status has-text-white px-4 py-2 ${statusReschedule(
                    dataHistory.status
                  )}`"
                >
                  <p
                    class="averta-regular label-14 color-white has-text-centered"
                    style="white-space: nowrap"
                  >
                    {{ statusReschedule(dataHistory.status, true) }}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Content Table -->
      </div>
      <!-- <div class="wrap-header is-flex is-align-items-center is-justify-content-space-between pb-4">
        <div class="is-flex is-align-items-center">
          <img :src="require('@/assets/img/calendar.png')" alt="calendar" class="mr-3" />
          <div>
            <p class="has-text-info">Jadwal Ulang Survey</p>
            <p>Permintaan Jadwal Ulang Survey <span class="averta-bold label-16">{{convertDate(dataHistory.actually_date || dataHistory.date)}} {{dataHistory.start_time ? `(${dataHistory.start_time})` : '' }}</span></p>
            <p>Diperbarui dari <span class="averta-bold text-merah">{{convertDate(dataHistory.original_date)}} {{dataHistory.original_start_time ? `(${dataHistory.original_start_time})` : '' }}</span></p>
          </div>
        </div>
        <div :class="`wrap-status has-text-white px-4 py-2 ${statusReschedule(dataHistory.status)}`">
          <p class="averta-bold">{{statusReschedule(dataHistory.status, true)}}</p>
        </div>
      </div>
      <div class="pt-4">
        <div :class="{'mb-5': dataHistory.date || dataHistory.reason}" v-if="dataHistory.created_by_name">
          <p class="text-grey">Oleh</p>
          <p class="averta-bold label-14">{{dataHistory.created_by_name}} {{dataHistory.created_by ? `#${dataHistory.created_by}` : ''}} <span class="is-italic averta-bold label-12 color-gray" v-if="dataHistory.created_by_role">{{dataHistory.created_by_role}}</span></p>
        </div>
        <div :class="{'mb-5': dataHistory.reason}" v-if="dataHistory.date && dataHistory.status !== 'Ditolak' && dataHistory.status !== 'Disetujui'">
          <p class="text-grey">Permintaan Jadwal Ulang Survey</p>
          <p class="averta-bold label-14">{{convertDate(dataHistory.actually_date || dataHistory.date)}} {{dataHistory.start_time ? `(${dataHistory.start_time})` : '' }}</p>
        </div>
        <div v-if="dataHistory.reason">
          <p class="text-grey">Alasan Jadwal Ulang Survey</p>
          <p class="averta-bold label-14">{{dataHistory.reason}}</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { ProyekEmptyIcon } from '@/components/icons'

export default {
  name: 'TabDetailHistoryReschedule',
  props: {
    dataHistoryReschedule: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    ProyekEmptyIcon
  },
  data () {
    return {
      moment: moment
    }
  },
  methods: {
    convertDate (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('dddd, DD MMMM YYYY')
    },
    statusReschedule (val, name) {
      switch (val) {
        case 'approve':
          return name ? 'Disetujui' : 'bg-green-2'
        case 'reject':
          return name ? 'Ditolak' : 'bg-red'
        case 'pending':
          return name ? 'Dalam Proses' : 'bg-dark-yellow'
        case 'cancel':
          return name ? 'Dibatalkan' : 'bg-dark-grey-4'
        default:
          return name || 'bg-dark-grey-4'
      }
    },
    safeSubstring (text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text

      const trimmed = text.substring(0, maxLength)
      const lastSpaceIndex = trimmed.lastIndexOf(' ')

      if (lastSpaceIndex === -1) return '-'

      return trimmed.substring(0, lastSpaceIndex) + '...'
    }
  }
}
</script>

<style scoped>
.wrap-history {
  margin-bottom: 20px;
}

.card {
  background: #fafdff;
  border: 2px solid #e5e5e5;
  border-radius: 12px;
}

.wrap-header {
  border-bottom: 2px dashed #e5e5e5;
}

.wrap-status {
  border-radius: 24px;
}

.content-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100px;
  max-height: 800px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
}

.header-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: #868686;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.body-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 70px;
  max-height: 500px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  overflow: auto !important;
  background: transparent;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #e1e1e1;
}

.body-table-history::-webkit-scrollbar {
  display: none;
}

.body-table-history {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.row-content-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
  gap: 5px;
}

.row-content-table-history:last-child {
  border-bottom: none !important;
}

.data-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden !important;
  background: transparent;
}

.badge-status {
  display: flex;
  flex-direction: row;
  width: auto;
  max-width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 0.85rem;
  background: #10bd41;
  border-radius: 100px;
}
</style>
